var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.5122C9.67225 13.5122 9.40625 13.2462 9.40625 12.9184V11.1602C9.40625 10.8324 9.67225 10.5664 10 10.5664C10.3278 10.5664 10.5938 10.8324 10.5938 11.1602V12.9184C10.5938 13.2462 10.3278 13.5122 10 13.5122Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2051 7.01722C15.9449 7.80968 16.6596 9.35142 16.6596 11.902C16.6596 15.9545 14.8554 17.4611 10.0016 17.4611C5.14796 17.4611 3.34375 15.9545 3.34375 11.902C3.34375 9.35173 4.05825 7.81005 5.79761 7.0175V5.67874C5.83482 3.37974 7.65723 1.56445 9.94591 1.53516C11.0843 1.5407 12.1325 1.94524 12.936 2.72899C13.7412 3.51432 14.1916 4.56407 14.2051 5.68745V7.01722ZM13.3313 7.91953C13.3808 7.94605 13.4345 7.96576 13.491 7.9774C14.9685 8.54708 15.4721 9.72991 15.4721 11.902C15.4721 15.2935 14.245 16.2736 10.0016 16.2736C5.75833 16.2736 4.53125 15.2935 4.53125 11.902C4.53125 9.72952 5.03499 8.54669 6.51304 7.97708C6.5687 7.96552 6.62152 7.94613 6.67029 7.92008C7.48372 7.64258 8.57134 7.53122 10.0016 7.53122C11.431 7.53122 12.5181 7.64242 13.3313 7.91953ZM6.98511 6.62552V5.68824C7.01123 4.04632 8.31827 2.74324 9.96174 2.72266C10.7819 2.71711 11.5308 3.01716 12.108 3.58003C12.6851 4.14291 13.0081 4.89578 13.0176 5.69457V6.62537C12.1805 6.43263 11.1811 6.34372 10.0016 6.34372C8.82198 6.34372 7.8224 6.43267 6.98511 6.62552Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.2ca96a1b02a43a80fabbfc70e69dfeb5.svg";
export { ForwardRef as ReactComponent };